// NetworkStatus.jsx
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { toast } from 'react-toastify';
import Cookies from "js-cookie";

const NetworkStatus = ({ setNetworkStatusVar }) => {
  const {t, i18n } = useTranslation();
  useEffect(() => {
    const handleOnline = () => {
      setNetworkStatusVar('online');
      showToast('success','NetworkStatus.Online');
    };

    const handleOffline = () => {
      setNetworkStatusVar('offline');
      showToast('error','NetworkStatus.Offline');
    };

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, [setNetworkStatusVar]);

  const showToast = (type, messageKey) => {
    const position = i18n.language === 'ar' ? 'top-left' : 'top-right';
    const id = `network-${type}`;
    const theme_mode = Cookies.get("theme-mode") === "dark" ? 'dark':'light'

    toast.dismiss(); // Dismiss any previous toasts
    toast[type](t(messageKey), {
      position,
      toastId: id,
      theme: theme_mode,
    });
  };

  useEffect(() => {
const checkSpeed = () => {
  const start = performance.now();
  const img = new Image();

  // img.onload = () => {
  //   const duration = performance.now() - start;
  //   if (duration > 1000) {
  //     showToast('warn', 'NetworkStatus.SlowInternet');
  //     setNetworkStatusVar('slow');
  //   } else {
  //     setNetworkStatusVar('online');
  //   }
  // };

  img.onerror = () => {
    showToast('error','NetworkStatus.SlowOrOffline');
    setNetworkStatusVar('offline');
  };

  // Use a reliable small image with no CORS issues
  img.src = 'https://upload.wikimedia.org/wikipedia/commons/3/3f/Placeholder_view_vector.svg?' + new Date().getTime();
};


    const interval = setInterval(checkSpeed, 15000);
    return () => clearInterval(interval);
  }, [setNetworkStatusVar]);

  return null;
};

export default NetworkStatus;
